import { AppErrorSeverity } from '@chronosphereio/core';
import { Theme } from '@chronosphereio/chrono-ui';

export const borderColor = (severity: AppErrorSeverity, theme: Theme) => {
  if (severity === 'error') return theme.palette.error.main;
  else if (severity === 'warning') return theme.palette.warning.main;
  return theme.palette.border.prominent;
};

export const backgroundColor = (severity: AppErrorSeverity, theme: Theme) => {
  if (severity === 'error') return theme.palette.error.light;
  else if (severity === 'warning') return theme.palette.warning.light;
  return theme.palette.background.paper;
};

export const textColor = (severity: AppErrorSeverity, theme: Theme) => {
  if (severity === 'error') return theme.palette.error.dark;
  else if (severity === 'warning') return theme.palette.warning.dark;
  return theme.palette.text.secondary;
};
